module.exports = __webpack_public_path__ + "media/images/clients/momo1-e7db240fa677572528452b9350da1e8f.png";